import { createFetcher, createServerSidePaginatedFetcher } from '../../contexts/Fetcher';
import { useCallback, useContext } from 'react';
import { IOrganizationUrlParams } from '../../pages/Organization';
import { apiOrganization } from '../../resources/api/apiOrganization';
import { apiOrganizationProduct } from '../../resources/api/apiOrganizationProduct';
import { useDecodedParams } from '../../hooks/useDecodedParams';
import { OrganizationContext } from '../../contexts/OrganizationContext';
import { apiScheduled } from '../../resources/api/apiScheduled';
import { ISupportListResponse } from '../../hooks/useSupportApi';
import { ICustomerInvoicesResponse } from '../../models/CustomerInvoicesResponse';

const { useGetOrganizationByName, useListOrganizationUsers } = apiOrganization;
const { useGetOrganizationProducts, useGetPlansAvailable } = apiOrganizationProduct;
const { useGetOrganizationTasks } = apiScheduled;

export const OrganizationFetcher = createFetcher(() => {
  const { organization_name } = useDecodedParams<{ organization_name: string }>();

  const { execute } = useGetOrganizationByName(organization_name);

  return execute;
});

export const OrganizationProductsFetcher = createFetcher(() => {
  const { organization } = useContext(OrganizationContext);

  const { execute } = useGetOrganizationProducts(organization ?? void 0);

  return execute;
});

export const OrganizationScheduledProductsFetcher = createFetcher(() => {
  const { organization } = useContext(OrganizationContext);
  return useGetOrganizationTasks(organization ?? void 0).execute;
});

export const CustomerUsersFetcher = createServerSidePaginatedFetcher(() => {
  const { organization_name } = useDecodedParams<IOrganizationUrlParams>();
  const { execute } = useListOrganizationUsers(organization_name);

  return execute;
});

export const CustomerTicketsFetcher = createFetcher(() => {
  // @todo needs refactoring
  return useCallback(async () => null as null | ISupportListResponse, []);
});

export const CustomerInvoicesFetcher = createFetcher(() => {
  // @todo needs refactoring
  return useCallback(async () => null as null | ICustomerInvoicesResponse, []);
});

export const OrganizationAvailableProductsFetcher = createFetcher(() => {
  const { organization } = useContext(OrganizationContext);

  return useGetPlansAvailable(organization ?? void 0).execute;
});
